module.exports = __webpack_public_path__ + "img/icon.00c0e269.png";